import { FC } from 'react';

import Icon from 'atoms/Icons/Icon';
import color from 'atoms/colors/colors';

// Quarks
import Flex from 'quarks/Flex';

type SliderArrowsProps = {
  activeIndex?: number;
  setActiveIndex?: () => void;
  length?: number;
};

const SliderArrows: FC<SliderArrowsProps> = ({ activeIndex, setActiveIndex, length }) => (
  <Flex gap="12px" justifyContent="flex-end">
    <Flex
      borderRadius="6px"
      backgroundColor="navy-50"
      width="36px"
      height="36px"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      onClick={() => (activeIndex === 0 ? setActiveIndex(length - 1) : setActiveIndex(activeIndex - 1))}
    >
      <Icon id="arrow-left" fill={color.gray[900]} size={16} />
    </Flex>
    <Flex
      borderRadius="6px"
      backgroundColor="navy-50"
      width="36px"
      height="36px"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      onClick={() => (activeIndex === length - 1 ? setActiveIndex(0) : setActiveIndex(activeIndex + 1))}
    >
      <Icon id="arrow-right" fill={color.gray[900]} size={16} />
    </Flex>
  </Flex>
);

export default SliderArrows;
